/* Diyar Usta — Özel kutu seçeneği (DU1940). Seçiliyse form gönderiminde kutu varyantı aynı adetle eklenir. */
(() => {
  if (customElements.get('du-box-option')) return;
  const money = (cents) => {
    try { return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY', minimumFractionDigits: 2 }).format(cents / 100); } catch { return (cents / 100).toFixed(2) + ' TL'; }
  };
  class DuBoxOption extends HTMLElement {
    connectedCallback() {
      this.map = {}; (this.dataset.map || '').split('|').map((x) => x.trim()).filter(Boolean).forEach((row) => { const [vid, id, price, ...t] = row.split(':'); this.map[vid] = { id: Number(id), price: Number(price), title: t.join(':') }; });
      this.form = document.getElementById(this.dataset.formId);
      this.check = this.querySelector('[data-du-box-check]');
      this.priceEl = this.querySelector('[data-du-box-price]');
      if (!this.form) return;
      this.update();
      // Dawn 16: varyant değişince pubsub olayı
      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
        this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(() => this.update(), 0));
      }
      this.form.addEventListener('change', () => this.update());
      this.check.addEventListener('change', () => this.syncProperty());
      // Dawn'ın submit handler'ından önce yakala (document capture)
      this.onSubmit = (e) => {
        if (e.target !== this.form || this.passThrough) return;
        if (!this.check.checked || !this.current) return;
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        const qty = parseInt(new FormData(this.form).get('quantity')) || 1;
        const props = {}; props['_du_box_for'] = String(this.currentVariantId()); props['Kutu'] = this.mainTitle();
        fetch(window.routes?.cart_add_url || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: this.current.id, quantity: qty, properties: props }] }) })
          .catch(() => {})
          .finally(() => { this.passThrough = true; this.form.requestSubmit(); setTimeout(() => (this.passThrough = false), 0); });
      };
      document.addEventListener('submit', this.onSubmit, true);
    }
    disconnectedCallback() { document.removeEventListener('submit', this.onSubmit, true); if (this.unsub) this.unsub(); }
    currentVariantId() { const i = this.form.querySelector('input[name="id"]'); return i ? i.value : null; }
    mainTitle() { const h = document.querySelector('.product__title h1, .product__title'); return h ? h.textContent.replace(/\s+/g, ' ').trim().slice(0, 80) : ''; }
    update() {
      const id = this.currentVariantId();
      this.current = id && this.map[id] ? this.map[id] : null;
      if (this.current) {
        this.hidden = false;
        this.priceEl.textContent = '(+' + money(this.current.price) + ' · ' + this.current.title + ')';
      } else {
        this.hidden = true; this.check.checked = false;
      }
      this.syncProperty();
    }
    syncProperty() {
      // Kutu seçiliyken sepeti atlayan 'Hemen satın al' yolları gizlenir (kutu sepet üzerinden eklenir)
      document.documentElement.classList.toggle('du-box-on', !!(this.check.checked && this.current));
      let input = this.form.querySelector('input[name="properties[Özel kutu]"]');
      if (this.check.checked && this.current) {
        if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'properties[Özel kutu]'; this.form.appendChild(input); }
        input.value = this.dataset.productTitle + ' (' + this.current.title + ')';
      } else if (input) input.remove();
    }
  }
  customElements.define('du-box-option', DuBoxOption);
})();
